// export const BASE_URL="http://localhost:5000/api"
// export const BASE_URL="https://futurabackend.vercel.app/api"

export const BASE_URL="https://futurabiolabs.com/api"

export const SERVER_ORIGIN = BASE_URL.replace(/\/api\/?$/, "");
export function resolveAssetUrl(value) {
  if (!value) return "";
  if (
    value.startsWith("data:") ||
    value.startsWith("blob:") ||
    value.startsWith("http://") ||
    value.startsWith("https://")
  ) {
    return value;
  }
  if (value.startsWith("/uploads/")) {
    return `${SERVER_ORIGIN}${value}`;
  }
  return value;
}